<template>
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16.5416 6.04172L7.70829 14.8751C7.66956 14.9141 7.62347 14.9451 7.5727 14.9663C7.52192 14.9874 7.46746 14.9983 7.41246 14.9983C7.35745 14.9983 7.30299 14.9874 7.25222 14.9663C7.20144 14.9451 7.15536 14.9141 7.11662 14.8751L2.62496 10.3834C2.5859 10.3447 2.55491 10.2986 2.53375 10.2478C2.5126 10.197 2.50171 10.1426 2.50171 10.0876C2.50171 10.0326 2.5126 9.97809 2.53375 9.92732C2.55491 9.87654 2.5859 9.83046 2.62496 9.79172L3.20829 9.20839C3.24703 9.16934 3.29311 9.13834 3.34388 9.11719C3.39466 9.09603 3.44912 9.08514 3.50412 9.08514C3.55913 9.08514 3.61359 9.09603 3.66437 9.11719C3.71514 9.13834 3.76122 9.16934 3.79996 9.20839L7.40829 12.8167L15.3666 4.85839C15.4459 4.78152 15.552 4.73853 15.6625 4.73853C15.7729 4.73853 15.879 4.78152 15.9583 4.85839L16.5416 5.45006C16.5807 5.48879 16.6117 5.53487 16.6328 5.58565C16.654 5.63642 16.6649 5.69089 16.6649 5.74589C16.6649 5.80089 16.654 5.85536 16.6328 5.90613C16.6117 5.9569 16.5807 6.00299 16.5416 6.04172Z"
      fill="currentColor"
    />
  </svg>
</template>
<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'Done',
} as DefineComponent
</script>
